<app-initialization class="w-100 h-100" (close)="_onAppInitialized($event)"></app-initialization>

@if (initialized) {
	<router-outlet></router-outlet>
}
